import LoadingSpinner from 'common/components/loading-spinner';
import styles from './styles.less';
import { observer } from 'mobx-react';


function LoadMoreButton({ className, loading, onClick, ...otherProps }) {
    return (
        <button
            className={ cx(styles.root, className) }
            onClick={ loading ? null : onClick }
            { ...otherProps }>
            { loading &&
            <LoadingSpinner className={ styles.loadingSpinner } /> }
            { !loading && 'Load More' }
        </button>
    );
}

LoadMoreButton.propTypes = {
    loading: React.PropTypes.bool
};

LoadMoreButton.defaultProps = {
    loading: false
};


export default observer(LoadMoreButton);



/** WEBPACK FOOTER **
 ** ./src/show-page/components/load-more-button/index.js
 **/